import { sendSearchData } from '@/Utils/webSocketUtils';

export const sendDesktopAuth = (userSelector: any) => {
    let payload = {
        event: 'auth',
        data: userSelector.token,
    };
    sendSearchData(JSON.stringify(payload));
};
